export default __webpack_public_path__ + "static/media/spain.e96835be.svg";